export default __webpack_public_path__ + "static/media/matching.948274c6.PNG";